import { Box, Popover, Typography } from '@mui/material';
import type { MouseEvent, ReactNode } from 'react';

interface Props {
  title: string;
  anchorElement: Element | null;
  open: boolean;
  labelledBy: string;
  handleClose: (e: MouseEvent) => void;
  children?: ReactNode;
  icon?: ReactNode;
  disclaimer?: string;
}

export const Prompt = ({
  children,
  icon,
  title,
  open,
  labelledBy,
  handleClose,
  anchorElement,
  disclaimer,
}: Props) => {
  return (
    <Popover
      id="missing-required-fields-prompt"
      aria-labelledby={labelledBy}
      anchorEl={anchorElement}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      sx={{
        ml: -2,
        mt: -2,
        p: 2,
      }}
    >
      <Box sx={{ display: 'flex', px: 2, pt: 2 }}>
        <Box>{icon}</Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', pl: 1, pb: 2 }}>
          <Box sx={{ display: 'flex', pb: 0.5 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: (theme) => theme.typography.fontWeightMedium }}
            >
              {title}
            </Typography>
          </Box>
          {children}
        </Box>
      </Box>
      {disclaimer ? (
        <Box
          sx={{
            p: 1,
            pl: 2,
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.10)',
          }}
        >
          <Typography
            sx={{
              fontSize: (theme) => theme.typography.pxToRem(13),
              fontWeight: (theme) => theme.typography.fontWeightLight,
              color: 'grey.1',
            }}
          >
            {disclaimer}
          </Typography>
        </Box>
      ) : null}
    </Popover>
  );
};
